import { render } from "./CourseVideoPlayer.vue?vue&type=template&id=c5491042&scoped=true"
import script from "./CourseVideoPlayer.vue?vue&type=script&lang=js"
export * from "./CourseVideoPlayer.vue?vue&type=script&lang=js"

import "./CourseVideoPlayer.vue?vue&type=style&index=0&id=c5491042&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5491042"]])

export default __exports__